import { COLLECTIONS, PATHS } from '__constants__'
import { generatePath, useLocation, useNavigate } from 'react-router-dom'
import { useEvent, useTranslations } from 'hooks'

import { deleteDocument } from 'services/api/firebase'
import { message } from 'antd'
import { useMemo } from 'react'

/* Path's */
const createPath =
  PATHS.AUTHENTICATED.CATEGORY_CREATE || PATHS.AUTHENTICATED.CATEGORY_WIZARD
const editPath = PATHS.AUTHENTICATED.CATEGORY_EDIT
const productsByCategoryShowPath = PATHS.AUTHENTICATED.PRODUCTS_ALL_BY_CATEGORY

const useCategoryBaseActions = ({ categoryId, actions } = {}) => {
  const location = useLocation()

  /* Getting translations instance */
  const { t } = useTranslations()
  /* Getting navigate instance */
  const navigate = useNavigate()

  /* Function to handle back click */
  const handleBack = useEvent(() => navigate(-1))

  /* Handling opening of the create page */
  const handleCreate = useEvent(() => {
    navigate(createPath)
  })

  /* Handling opening of the show page */
  const handleOpen = useEvent(() => {
    location.state = [...(location.state || []), location.pathname]

    const pathParams = { categoryId }
    const path = generatePath(productsByCategoryShowPath, pathParams)
    navigate(path)
  })

  /* Handling opening of the edit page or change view to edit mode */
  const handleEdit = useEvent(() => {
    const pathParams = { categoryId }
    const path = generatePath(editPath, pathParams)
    navigate(path)
  })

  const handleDelete = useEvent(async () => {
    try {
      await deleteDocument(COLLECTIONS.CATEGORIES, categoryId)
      message.success(t('Category successfully deleted'))
    } catch (error) {
      message.error(error.message)
    }
  })

  return useMemo(
    () => ({
      onBack: handleBack,
      onCreate: handleCreate,
      onOpen: handleOpen,
      onEdit: handleEdit,
      onDelete: handleDelete,
      ...(actions || {}),
      createPath,
      editPath,
      productsByCategoryShowPath
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      actions?.onBack,
      actions?.onCreate,
      actions?.onDelete,
      actions?.onEdit,
      actions?.onOpen,
      handleBack,
      handleCreate,
      handleDelete,
      handleEdit,
      handleOpen
    ]
  )
}

export default useCategoryBaseActions
